export const getFileNameFromUrl = (path?: string | null) => {
  if (!path) return "N/A";
  const regex = /\/([^\/]+)$/; // Matches the last part after the last '/'
 // const regex = /\/([^/]+)_(\d+)_\d{4}-\d{2}-\d{2}_\d{2}:\d{2}:\d{2}\.\w+$/;
  const match = path.match(regex);

  if (match && match.length > 1) {
    let filename = match[1];
 
    return filename;
  }
  return path || "N/A";
};

export const getFileExtensionFromUrl = (url?: string | null) => {
  if (!url) return "";
  return url.split(".").pop() || "";
};
